export default function HeroSection() {
  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="home"
      className="relative min-h-screen flex flex-col justify-center items-center overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=diverse%20business%20professionals%20standing%20together%20in%20a%20circle%20with%20hands%20joined%20in%20the%20center%2C%20teamwork%20and%20unity%20concept%2C%20warm%20professional%20office%20environment%2C%20soft%20natural%20lighting%2C%20overhead%20view%2C%20corporate%20team%20building%20moment%2C%20people%20supporting%20each%20other&width=1920&height=1080&seq=hero001&orientation=landscape"
          alt="チームワーク"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-gray-900/70 via-gray-900/60 to-gray-900/75" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full text-center px-6 md:px-10 flex flex-col items-center">
        {/* Label */}
        <div className="inline-flex items-center gap-2 border border-yellow-400/60 rounded-full px-4 py-1.5 mb-8">
          <span className="w-2 h-2 bg-yellow-400 rounded-full" />
          <span className="text-yellow-400 text-xs font-semibold tracking-widest uppercase">経営コンサルティング</span>
        </div>

        {/* Main Title */}
        <h1 className="text-white font-bold leading-tight mb-6">
          <span className="block text-4xl md:text-6xl lg:text-7xl mb-2">人と組織を、</span>
          <span className="block text-4xl md:text-6xl lg:text-7xl">
            <span className="text-yellow-400">次のステージ</span>へ。
          </span>
        </h1>

        {/* Sub Copy */}
        <p className="text-gray-300 text-base md:text-lg max-w-xl mb-10 leading-relaxed">
          大阪市北区を拠点に、企業の成長を全力でサポートします。<br />
          経営課題の解決から組織づくりまで、共に歩むパートナーとして。
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            onClick={() => scrollTo('#contact')}
            className="bg-yellow-400 text-gray-900 font-semibold px-8 py-3.5 rounded-full hover:bg-yellow-300 transition-colors cursor-pointer whitespace-nowrap text-sm md:text-base"
          >
            お問い合わせ
          </button>
          <button
            onClick={() => scrollTo('#services')}
            className="border border-white text-white font-semibold px-8 py-3.5 rounded-full hover:bg-white/10 transition-colors cursor-pointer whitespace-nowrap text-sm md:text-base"
          >
            サービスを見る
          </button>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-white/50 text-xs tracking-widest">SCROLL</span>
        <div className="w-px h-8 bg-gradient-to-b from-white/50 to-transparent" />
      </div>
    </section>
  );
}
